import { LIVE_VIEWER_ROLE, LiveViewerRole } from '../constants/liveSessionHeader';

interface LiveViewerFlags {
  /** On someone's desktop call with the user's own mic. */
  isCoSeller: boolean;
  /** On someone else's call, watched or co-sold (a co-seller is also a watcher). */
  isWatcher: boolean;
}

/** Who the signed-in user is on the live call, for row 1 of the live session header. */
export const resolveLiveViewerRole = ({ isCoSeller, isWatcher }: LiveViewerFlags): LiveViewerRole => {
  if (isCoSeller) return LIVE_VIEWER_ROLE.coSeller;
  if (isWatcher) return LIVE_VIEWER_ROLE.observer;
  return LIVE_VIEWER_ROLE.owner;
};
